import AddIcon from "@mui/icons-material/Add";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import TabContext from "@mui/lab/TabContext";
import {
  Collapse,
  Divider,
  GlobalStyles,
  IconButton,
  Slide,
  Typography,
  useTheme,
} from "@mui/material";
import Tab from "@mui/material/Tab";
import * as React from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  DownloadJd,
  getJdFileList,
  getJobDataDetail,
  getMatchedJdResumeData,
} from "../../../api/Api";
import CandidateHub from "../../../assets/icons/CandidateHub";
import CandidateSupportIco from "../../../assets/icons/CandidateSupportIco";
import HeartIco from "../../../assets/icons/HearIco";
import JobIco from "../../../assets/icons/JobIco";
import SkillDrag from "../../../assets/icons/SkillDrag";
import SummaryIco from "../../../assets/icons/SummaryIco";
import SupportIco from "../../../assets/icons/SupportIco";
import { ReactComponent as ChatBotIcon } from "../../../assets/images/ChatBotIcon.svg";
import { ReactComponent as SupportHaley } from "../../../assets/images/SupportHaley.svg";
import CommonButton from "../../../component/Button";
import SnackBar from "../../../component/SnackBar";
import {
  ChatBotCall,
  ChatBotGetCall,
  SupportCall,
  SupportGetCall,
} from "../../../redux/action/ChatBot";
import {
  checkBackGroundProcess,
  JobJobFormikData,
  JobJobSubmit,
  JobSummary,
} from "../../../redux/action/Job";
import { UploadJob } from "../../../redux/action/QuickMatch";
import { GET, GETDOWNLOAD } from "../../../redux/axios/Axios";
import { HandleSkeletion } from "../../../utils/constants";
import SideBarChatBot from "../../chat-bot/SIdeBarChatBot";
import { CustomDiv } from "../../chat-bot/style";
import {
  CommonGrid2,
  CustomTooltip,
  JudicaCandidateTabViewSection,
  JudicaTabViewSection,
  TabPanelView,
} from "../../common-components/StyledComponents";
import JemPlus from "../../ignite/judica/components/JemPlus";
import DownloadJD from "../../jobs/job-information/download-jd";
import JobsCandidate from "../../jobs/jobs-candidate";
import DialogCandidateHub from "../../jobs/jobs-candidate/components/DialogCandidateHub";
import JobsSummary from "../../jobs/jobs-summary";
import { ChatBotRelative, CommonTippy } from "../../jobs/style";
import AddMoreCandidate from "../../matches/quick-match/components/AddMoreCandidate";
import useMeasure from "react-use-measure";

export default function QuickMatchDemo({ handleDemoBack }) {
  const location = useLocation();
  const [bounds] = useMeasure();
  const query = new URLSearchParams(useLocation().search);
  const jobId = query.get("id");
  const gridRef = React.useRef(null);
  const theme = useTheme();
  const [value, setValue] = React.useState("0");
  const [jobData, setJobData] = React.useState({});
  const [openDownloadJdDialog, setOpenDownloadJdDialog] = React.useState(false);
  const [jdFileList, setJdFileList] = React.useState([]);
  const [jdFileListLoader, setJdFileListLoader] = React.useState(false);
  const dispatch = useDispatch();
  const [resumeTab, setResumeTab] = React.useState([]);
  const [resumeScore, setResumeScore] = React.useState([]);
  const resumeId = resumeTab[value - 2]?.id;
  const filteredResumeTab = resumeTab.filter((item) => item.id !== resumeId);
  const [matchedData, setMatchedData] = React.useState({});
  const [resumeLoader, setResumeLoader] = React.useState(false);
  const valueLocation = useLocation().search;
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = React.useState(false);
  const [tableLoader, setTableLoader] = React.useState(false);
  const [minimizeScreen, setMinimizeScreen] = React.useState(false);
  const [addMoreCandidateDialogOpen, setAddMoreCandidateDialogOpen] =
    React.useState(false);
  const [isAddMoreCandidateDragging, setIsAddMoreCandidateDragging] =
    React.useState(false);
  const [addMoreCandidateFiles, setAddMoreCandidateFiles] = React.useState([]);
  const [snackbarState, setSnackbarState] = React.useState({
    open: false,
    message: "",
    severity: "error",
  });
  const [saveEditData, setSaveEditData] = React.useState({
    open: false,
    prevData: "",
    leaveLoading: false,
    disabled: false,
    saveLoading: false,
    view: false,
  });
  const [open, setOpen] = React.useState(true);
  const JobJobEditData = useSelector((state) => state.jobs.jobJobEditData);
  const tabData = [
    { name: "Summary", icon: <SummaryIco /> },
    { name: "Job", icon: <JobIco /> },
  ];
  const [backGroundprocess, setBackGroundprocess] = React.useState({
    open: false,
    openLoading: false,
    buttonLoading: false,
  });
  const [gridHeight, setGridHeight] = React.useState(null);
  const [chatBotData, setChatBotData] = React.useState({
    message: [
      { sender: "bot", text: "Hi, I am Hailey. How can I assist you today?" },
    ],
    value: "",
    loader: false,
    pageLoader: false,
    arrow: true,
    bubble: [],
    bubbleCondition: false,
    selectedValue: "Job",
  });
  const [isBottomVisible, setIsBottomVisible] = React.useState(true);
  const localStorageData = JSON.parse(localStorage.getItem("credential"));
  const buttonSupport = [
    {
      name: "Job",
      icon: <CandidateSupportIco />,
    },
    {
      name: "Support",
      icon: <SupportIco />,
    },
  ];

  const handleChange = (event, newValue) => {
    if (
      JSON.stringify(JobJobEditData.formikData) !==
      JSON.stringify(JobJobEditData.jobData)
    ) {
      setSaveEditData((prev) => ({
        ...prev,
        open: true,
        prevData: newValue,
        view: false,
      }));
    } else {
      setValue(newValue);
      const index = newValue - 2;
      const resumeId = resumeTab[newValue - 2]?.id;

      const urlParams = new URLSearchParams(valueLocation);
      urlParams.delete("value");
      urlParams.append("value", newValue);
      const newUrl = `/onboarding?${urlParams.toString()}`;
      navigate(newUrl);
      if (newValue && parseInt(newValue) >= 2) {
        fetchResumeData(resumeId, index);
      }
    }
  };

  const handleSaveCandidate = () => {
    setSaveEditData({
      open: false,
      prevData: "",
      leaveLoading: false,
      disabled: false,
      saveLoading: false,
      view: false,
    });
  };

  const handlebackGroundWarningClose = () => {
    setBackGroundprocess({
      open: false,
      openLoading: false,
      buttonLoading: false,
    });
  };

  const handlebackGroundWarning = () => {
    setBackGroundprocess((prev) => ({
      ...prev,
      buttonLoading: true,
    }));
    setTimeout(() => {
      handlebackGroundWarningClose();
    }, 1000);
  };

  const handleClick = () => {
    setSaveEditData((prev) => ({
      ...prev,
      open: true,
      prevData: "2",
      view: false,
    }));
  };

  const fetchJobDataDetail = async () => {
    if (jobId) {
      setTableLoader(true);
      setResumeLoader(true);

      try {
        const res = await GET(getJobDataDetail(jobId));
        setJobData(res?.data);
        setResumeTab(res?.data?.resumes || []);

        setResumeScore(res?.data?.rescore_resumes || []);
        const queryValue = query?.get("value");
        const resumeData = res?.data?.resumes;

        if (queryValue >= "2" && resumeData.length !== 0) {
          const data = resumeData[queryValue - 2]?.id;
          const index = queryValue - 2;
          setValue(queryValue);
          await fetchResumeData(data, index, resumeData, "");
        }
        setTableLoader(false);
        setResumeLoader(false);
      } catch (error) {
        setTableLoader(false);
        setResumeLoader(false);
        setSnackbarState({
          open: true,
          severity: "error",
          message: error?.message,
        });
      }
    } else {
    }
  };

  const fetchResumeData = async (resumeId, index, resumeObj, paramLabel) => {
    setResumeLoader(true);

    try {
      const data = await GET(getMatchedJdResumeData(resumeId), paramLabel);
      let arr = [...(resumeObj ? resumeObj : resumeTab)];
      let detailObj = {
        ...data?.data,
        candidate_name: data?.data?.resume_info?.candidate_name,
        pay_rate: data?.data?.resume_info?.pay_rate,
        location: data?.data?.resume_info?.location,
        inferred_title: data?.data?.resume_info?.inferred_title,
        visa_info: data?.data?.resume_info?.visa_info,
        website: data?.data?.resume_info?.website,
        email: data?.data?.resume_info?.email,
        overall_score: data?.data?.quick_match_score?.overall_score,
        results: data?.data?.results || [],
        skill_calculation: data?.data?.skill_calculation,
        error_message: data?.data?.error_message,
        resume_id: data?.data?.resume_id,
        // file_name: data?.resume_file_name,
        spider_graph_results: data?.data?.spider_graph_results,
        file_name: data?.data?.resume_file_name,
        insights: data?.data?.insights,
        feedback: data?.data?.feedback,
        match_summary: data?.data?.match_summary,
        experience: data?.data?.experience,
        coversheet_added: data?.data?.coversheet_added,
        data: {
          personal_details: {
            candidate_name: data?.data?.resume_info?.candidate_name,
            inferred_title: data?.data?.resume_info?.inferred_title,
          },
        },
      };
      if (arr[index]) {
        arr[index] = {
          ...arr[index],
          details: detailObj,
        };
      }
      // else if (resumeObj) {
      //   arr.push({
      //     ...resumeObj,
      //     details: detailObj,
      //   });
      // }
      if (arr.length === 0) {
        setValue("0");
      }

      setResumeTab(arr);
      setMatchedData(arr[index]?.details);

      setResumeLoader(false);
    } catch (error) {
      setSnackbarState({
        open: true,
        severity: "error",
        message: error?.response?.data?.message,
      });
      setResumeLoader(false);
    }
  };

  React.useEffect(() => {
    fetchJobDataDetail();
  }, [jobId]);

  //dame notes

  const handleCloseDownloadJdDialog = () => {
    setOpenDownloadJdDialog(false);
  };

  const handleDownloadJd = (row) => {
    if (row.id) {
      GETDOWNLOAD(DownloadJd(row.id), {
        params: { type: "match_resume" },
        responseType: "blob",
      })
        .then((response) => {
          const contentType = response.headers["content-type"];
          const extension =
            contentType === "application/pdf"
              ? "pdf"
              : contentType ===
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
              ? "docx"
              : "doc";

          const fileName = `${row?.file_name}.${extension}`;

          const url = window.URL.createObjectURL(
            new Blob([response.data], { type: contentType })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch((error) => {
          if (error.response && error.response.data instanceof Blob) {
            const reader = new FileReader();
            reader.onload = () => {
              const responseText = reader.result;
              try {
                const json = JSON.parse(responseText);
                const errorMessage =
                  json.error || "An unexpected error occurred.";
                setSnackbarState({
                  open: true,
                  severity: "error",
                  message: errorMessage,
                });
              } catch (e) {
                setSnackbarState({
                  open: true,
                  severity: "error",
                  message:
                    "An unexpected error occurred while parsing the error message.",
                });
              }
            };
            reader.readAsText(error.response.data);
          } else {
            setSnackbarState({
              open: true,
              severity: "error",
              message: "An unexpected error occurred.",
            });
          }
        });
    } else {
      setSnackbarState({
        open: true,
        severity: "error",
        message: "JD was not parsed successfully. Unable to download.",
      });
    }
  };

  const fetchJdFileList = async () => {
    setJdFileListLoader(true);
    if (jobId) {
      try {
        const res = await GET(getJdFileList(jobId));
        if (res?.success) {
          setJdFileList(res?.data);
          setJdFileListLoader(false);
        }
      } catch (error) {
        setJdFileListLoader(false);
      }
    }
  };

  const handleDownloadJdOpen = () => {
    setOpenDownloadJdDialog(true);
    fetchJdFileList();
  };
  //add more candidate functionality

  const allowedTypes = [
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ];

  const commonFileValidationCheck = (
    commonFiles,
    allowedTypes,
    setCommonFiles,
    existingFiles
  ) => {
    const validFiles = [];
    const invalidFiles = [];

    commonFiles.forEach((file) => {
      if (allowedTypes.includes(file.type)) {
        validFiles.push({
          file,
          name: file.name,
          size: `${(file.size / 1024).toFixed(1)} KB`,
          type: file.type,
          progress: 0,
          buffer: 0,
          visible: false,
          delete: true,
          message: "",
        });
      } else {
        invalidFiles.push(file.name);
      }
    });

    const mergedFiles = [
      ...existingFiles,
      ...validFiles.filter(
        (newFile) =>
          !existingFiles.some(
            (existingFile) => existingFile.name === newFile.name
          )
      ),
    ];
    setCommonFiles(mergedFiles);

    if (invalidFiles.length > 0) {
      setSnackbarState({
        open: true,
        message: `Unsupported file types: ${invalidFiles.join(", ")}`,
        severity: "error",
      });
    }
  };

  const handleAddMoreCandidateDialogClose = () => {
    setAddMoreCandidateDialogOpen(false);
    setAddMoreCandidateFiles([]);
  };

  const handleAddMoreCandidateOpen = async () => {
    if (
      JSON.stringify(JobJobEditData.formikData) !==
      JSON.stringify(JobJobEditData.jobData)
    ) {
      handleClick();
    } else {
      setBackGroundprocess((prev) => ({
        ...prev,
        openLoading: true,
      }));
      try {
        const data = await checkBackGroundProcess(jobId);
        if (!data?.background_process_status) {
          setAddMoreCandidateDialogOpen(true);
        }
        setBackGroundprocess((prev) => ({
          ...prev,
          open: data?.background_process_status,
          openLoading: false,
        }));
      } catch (error) {
        setBackGroundprocess((prev) => ({
          ...prev,
          openLoading: false,
        }));
        setSnackbarState({
          open: true,
          message: error.message,
          severity: "error",
        });
      }
    }
  };

  const handleAddMoreCandidateFileUpload = (event) => {
    const selectedFiles = Array.from(event.target.files);
    commonFileValidationCheck(
      selectedFiles,
      allowedTypes,
      setAddMoreCandidateFiles,
      addMoreCandidateFiles
    );
  };

  const handleAddMoreCandidateDeleteFile = (index) => {
    setAddMoreCandidateFiles((prevFiles) =>
      prevFiles.filter((_, i) => i !== index)
    );
  };

  const handleAddMoreCandidateDragOver = (event) => {
    event.preventDefault();
    setIsAddMoreCandidateDragging(true);
  };

  const handleAddMoreCandidateDragLeave = () => {
    setIsAddMoreCandidateDragging(false);
  };

  const handleAddMoreCandidateDrop = (event) => {
    event.preventDefault();
    setIsLoading(false);
    setIsAddMoreCandidateDragging(false);

    const droppedFiles = Array.from(event.dataTransfer.files);
    commonFileValidationCheck(
      droppedFiles,
      allowedTypes,
      setAddMoreCandidateFiles,
      addMoreCandidateFiles
    );
  };

  const processJsonResponse = (
    jsonResponse,
    getName,
    setCandidateFiles,
    getAddMore
  ) => {
    const { success, data, message } = jsonResponse;
    if (success && data?.percent !== undefined) {
      setCandidateFiles((prevFiles) =>
        prevFiles.map((f) =>
          f.name === data.current_resume
            ? {
                ...f,
                progress: data.percent,
                buffer: data.buffer || data.percent,
                visible: false,
                delete: false,
                progress_message: data.progress_message,
              }
            : f
        )
      );
    } else if (getAddMore === "Add-more-Candidate" && data?.length !== 0) {
      setAddMoreCandidateDialogOpen(false);
      setAddMoreCandidateFiles([]);
      if (Array.isArray(data) && data.length > 0 && data[0]?.jd_info) {
        let responseId = data[0]?.id;
        let arr = [...resumeTab];
        let resumeObj = {
          id: responseId,
          name: data[0]?.resume_info?.candidate_name
            ? data[0]?.resume_info?.candidate_name
            : "",
          score: data[0]?.quick_match_score?.overall_score
            ? data[0]?.quick_match_score?.overall_score
            : data[0]?.score,
          file_name: data[0]?.resume_file_name,
        };
        arr.push(resumeObj);
        setResumeTab(arr);
        fetchSummaryDetails();
        fetchJobDataDetail();
      }
    } else if (!success) {
      setCandidateFiles((prevFiles) =>
        prevFiles.map((f) =>
          f.name === data.current_resume || data.length === 0
            ? {
                ...f,
                visible: true,
                delete: true,
                message: message,
              }
            : { ...f, delete: true }
        )
      );
    }
  };

  const fetchSummaryDetails = async () => {
    try {
      setTableLoader(true);
      await dispatch(JobSummary(jobId));
      setTableLoader(false);
    } catch (error) {
      setSnackbarState({
        open: true,
        message: error?.data?.message || error?.message,
        severity: "error",
      });
      setTableLoader(false);
    }
  };

  const uploadFile = async (getName, setCandidateFiles, getAddMore) => {
    setIsLoading(true);

    setCandidateFiles((prevFiles) =>
      prevFiles.map((f) => ({
        ...f,
        delete: false,
      }))
    );

    const formData = new FormData();
    if (getAddMore === "Add-more-Candidate") {
      addMoreCandidateFiles.forEach((fileObj, index) => {
        formData.append("resume_file", fileObj.file);
      });
      formData.append("id", jobId);

      try {
        const response = await UploadJob(formData, getName, "Active");
        const reader = response.body.getReader();
        const decoder = new TextDecoder("utf-8");
        let buffer = "";

        while (true) {
          const { value, done } = await reader.read();
          if (done) break;
          const chunk = decoder.decode(value, { stream: true });
          buffer += chunk;
          let boundaryIndex;
          while ((boundaryIndex = buffer.indexOf("}\n")) !== -1) {
            const jsonString = buffer.slice(0, boundaryIndex + 1);
            buffer = buffer.slice(boundaryIndex + 1);
            const jsonResponse = JSON.parse(jsonString);
            try {
              await processJsonResponse(
                jsonResponse,
                getName,
                setCandidateFiles,
                getAddMore
              );
            } catch (e) {
              setSnackbarState({
                open: true,
                message: "Error parsing JSON",
                severity: "error",
              });
              setCandidateFiles((prevFiles) =>
                prevFiles.map((f) =>
                  f.name === jsonResponse.data.current_resume
                    ? {
                        ...f,
                        visible: true,
                        delete: true,
                      }
                    : { ...f, delete: true }
                )
              );
            }
          }
        }

        if (buffer) {
          const jsonResponse = JSON.parse(buffer);
          try {
            await processJsonResponse(
              jsonResponse,
              getName,
              setCandidateFiles,
              getAddMore
            );
          } catch (e) {
            setSnackbarState({
              open: true,
              message: "Error parsing final JSON chunk",
              severity: "error",
            });
            setCandidateFiles((prevFiles) =>
              prevFiles.map((f) =>
                f.name === jsonResponse.data.current_resume
                  ? {
                      ...f,
                      visible: true,
                      delete: true,
                    }
                  : { ...f, delete: true }
              )
            );
          }
        }
        setIsLoading(false);
      } catch (error) {
        setSnackbarState({
          open: true,
          message: "Error during the request",
          severity: "error",
        });
        setCandidateFiles((prevFiles) =>
          prevFiles.map((f) => ({
            ...f,
            visible: true,
            delete: true,
            message: "Error during the request",
          }))
        );

        setIsLoading(false);
      }
    }
  };

  const handleAddMoreCandidateClick = async () => {
    if (addMoreCandidateFiles.length === 0) {
      setSnackbarState({
        open: true,
        message: "Upload the Files",
        severity: "error",
      });
    } else {
      uploadFile(
        "Upload-Candidate",
        setAddMoreCandidateFiles,
        "Add-more-Candidate"
      );
    }
  };

  const handleCloseValidation = () => {
    setSnackbarState((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const handleLeave = async () => {
    setSaveEditData((prev) => ({
      ...prev,
      disabled: true,
      leaveLoading: true,
    }));
    await dispatch(
      JobJobFormikData(JobJobEditData.formikData, JobJobEditData.formikData)
    );
    try {
      await new Promise((resolve) => setTimeout(resolve, 1000));

      setSaveEditData((prev) => ({
        ...prev,
        disabled: false,
        leaveLoading: false,
        open: false,
        view: prev.prevData === "2" ? true : false,
      }));

      callBack(saveEditData.prevData);
    } catch (error) {}
  };

  const handleSave = async () => {
    setSaveEditData((prev) => ({
      ...prev,
      disabled: true,
      saveLoading: true,
    }));

    const values = JobJobEditData.jobData;
    const result = (valueData) => {
      if (!valueData) return [];

      const processedData = valueData.reduce((acc, { name, content }) => {
        const existing = acc.find((item) => item.name === name);
        if (existing) {
          existing.content.push(content);
        } else {
          acc.push({ name, content: [content] });
        }
        return acc;
      }, []);

      const extracted = processedData.find((item) => item.name === "extracted");
      const inferred = processedData.find((item) => item.name === "inferred");
      const userAdded = processedData.find(
        (item) => item.name === "user_added"
      );

      const resultData = [];
      if (!extracted) {
        resultData.push({ name: "extracted", content: [] });
      } else {
        resultData.push(extracted);
      }
      if (!inferred) {
        resultData.push({ name: "inferred", content: [] });
      } else {
        resultData.push(inferred);
      }
      const otherData = processedData.filter(
        (item) =>
          item.name !== "extracted" &&
          item.name !== "inferred" &&
          item.name !== "user_added"
      );
      resultData.push(...otherData);
      if (!userAdded) {
        resultData.push({ name: "user_added", content: [] });
      } else {
        resultData.push(userAdded);
      }
      return resultData;
    };

    const data = {
      ...JobJobEditData,
      ...values,
      employer_targets: result(values.employer_targets),
      certificates: result(values.certificates),
      languages: result(values.languages),
      shift: values.shift.map((item) => item.content),
      location_targets: result(values.location_targets),
      high_priority: values.skillData.high_priority,
      low_priority: values.skillData.low_priority,
      medium_priority: values.skillData.medium_priority,
      recommended: values.skillData.recommended,
    };

    try {
      dispatch(JobJobFormikData(values, values));
      const jobEdit = await JobJobSubmit(values.id, data);
      setSnackbarState({
        open: true,
        severity: "success",
        message: jobEdit.message,
      });
      setSaveEditData((prev) => ({
        ...prev,
        disabled: false,
        saveLoading: false,
        open: false,
        view: prev.prevData === "2" ? true : false,
      }));
      callBack(saveEditData.prevData);
    } catch (error) {
      dispatch(JobJobFormikData(JobJobEditData.jobData, values));
      setSnackbarState({
        open: true,
        severity: "error",
        message: error.message,
      });
      setSaveEditData((prev) => ({
        ...prev,
        disabled: false,
        saveLoading: false,
        view: false,
      }));
    }
  };

  const callBack = (newValue) => {
    setValue(newValue);
    const index = newValue - 2;
    const resumeId = resumeTab[newValue - 2]?.id;
    const urlParams = new URLSearchParams(valueLocation);
    urlParams.delete("value");
    urlParams.append("value", newValue);
    const newUrl = `/onboarding?${urlParams.toString()}`;
    navigate(newUrl);
    if (newValue && parseInt(newValue) >= 2) {
      fetchResumeData(resumeId, index);
    }
  };

  const Footer = () => (
    <CommonGrid2 display={"flex"} gap={"1rem"}>
      <CommonButton
        value={"Leave"}
        variant="outlined"
        color="#344054"
        width={"100%"}
        padding={"10px"}
        marginTop={"2rem"}
        fontWeight={"700"}
        fontSize={"15px"}
        border={"#D0D5DD"}
        onClick={handleLeave}
        disabled={saveEditData.disabled}
        loading={saveEditData.leaveLoading}
      />
      <CommonButton
        value={"Save"}
        width={"100%"}
        padding={"10px"}
        marginTop={"2rem"}
        fontWeight={"700"}
        fontSize={"15px"}
        disabled={saveEditData.disabled}
        loading={saveEditData.saveLoading}
        onClick={handleSave}
      />
    </CommonGrid2>
  );

  const BackGroundFooter = () => (
    <CommonGrid2 display={"flex"} gap={"1rem"}>
      <CommonButton
        value={"OK"}
        width={"100%"}
        padding={"10px"}
        marginTop={"2rem"}
        fontWeight={"700"}
        fontSize={"15px"}
        onClick={handlebackGroundWarning}
        disabled={backGroundprocess.buttonLoading}
        loading={backGroundprocess.buttonLoading}
      />
    </CommonGrid2>
  );

  const onDragEnd = (result) => {
    if (!result.destination) return;

    const reorderedTabs = [...resumeTab];
    const [movedItem] = reorderedTabs.splice(result.source.index, 1);
    reorderedTabs.splice(result.destination.index, 0, movedItem);
    setResumeTab(reorderedTabs);
  };

  const handleOverwriteClick = () => {
    setMinimizeScreen((prev) => !prev);
  };

  const handleChatBotFetchData = async () => {
    setChatBotData((prev) => ({
      ...prev,
      pageLoader: true,
      message: [],
    }));
    try {
      const data = await ChatBotGetCall(jobId);
      const messages = [];
      data?.data?.history?.forEach((entry) => {
        if (entry.user) {
          const userMessage = {
            sender: "user",
            text: entry.user,
          };
          messages.push(userMessage);
        }
        if (entry.assistant) {
          const botMessage = {
            sender: "bot",
            text: entry.assistant,
          };
          messages.push(botMessage);
        }
      });

      setChatBotData((prev) => ({
        ...prev,
        message: [
          {
            sender: "bot",
            text: "Hi, I am Hailey. How can I assist you today?",
          },
          ,
          ...messages,
        ],
        bubble: data?.data?.bubble_questions,
        pageLoader: false,
      }));
      setIsBottomVisible(false);
    } catch (error) {
      setChatBotData((prev) => ({
        ...prev,
        pageLoader: false,
      }));
    }
  };

  const handleSendMessage = async () => {
    if (!chatBotData.value.trim()) return;

    let payload;
    if (chatBotData.selectedValue === "Job") {
      payload = {
        query: chatBotData.value,
        filter_criteria: {
          type: "match_data",
          job_data_id: jobId,
        },
      };
    } else {
      payload = {
        query: chatBotData.value,
        filter_criteria: {
          type: "user_manuals",
          user_id: localStorageData?.user_id,
        },
      };
    }
    setMinimizeScreen(true);
    setChatBotData((prev) => ({
      ...prev,
      message: [...prev.message, { sender: "user", text: chatBotData.value }],

      loader: true,
      value: "",
    }));

    try {
      let data;
      if (chatBotData.selectedValue === "Job") {
        data = await dispatch(ChatBotCall(payload));
      } else {
        data = await SupportCall(payload);
      }
      const botResponse = {
        sender: "bot",
        text: data?.data?.response,
      };
      setChatBotData((prev) => ({
        ...prev,
        message: [...prev.message, botResponse],

        loader: false,
      }));
    } catch (error) {
      const botResponse = {
        sender: "error",
        text: error?.data?.message,
      };
      setChatBotData((prev) => ({
        ...prev,
        message: [...prev.message, botResponse],

        loader: false,
        value: "",
      }));
    }
  };

  const handleChatBotChange = (event) => {
    if (event.type === "keydown") {
      if (event.key === "Enter" && !event.shiftKey) {
        event.preventDefault();
        handleSendMessage();
      }
      return;
    }

    setChatBotData((prev) => ({
      ...prev,
      value: event.target.value,
    }));
  };

  const handleUpArrow = (condition) => {
    setChatBotData((prev) => ({
      ...prev,
      arrow: condition === "up" ? false : true,
    }));
  };

  const handleToggleDrawer = () => {
    setChatBotData((prev) => ({
      ...prev,
      selectedValue: "Job",
    }));
    setOpen((prev) => !prev);
  };

  const handleButtonSupport = (name) => {
    setChatBotData((prev) => ({
      ...prev,
      selectedValue: name === "Report Bug" ? prev.selectedValue : name,
    }));
    if (name === "Support") {
      handleSupportCall();
    } else if (name === "Job") {
      handleChatBotFetchData();
    }
  };

  const handleSupportCall = async () => {
    setChatBotData((prev) => ({
      ...prev,
      pageLoader: true,
      message: [],
    }));
    try {
      const data = await SupportGetCall(localStorageData?.user_id);

      const messages = [];
      data?.history?.forEach((entry) => {
        if (entry.user) {
          const userMessage = {
            sender: "user",
            text: entry.user,
          };
          messages.push(userMessage);
        }
        if (entry.assistant) {
          const botMessage = {
            sender: "bot",
            text: entry.assistant,
          };
          messages.push(botMessage);
        }
      });

      setChatBotData((prev) => ({
        ...prev,
        message: [
          {
            sender: "bot",
            text: "Hi, I am Hailey. How can I assist you today?",
          },
          ,
          ...messages,
        ],
        bubble: data?.data?.bubble_questions,
        pageLoader: false,
      }));
      setIsBottomVisible(false);
    } catch (error) {
      setChatBotData((prev) => ({
        ...prev,
        pageLoader: false,
      }));
      setSnackbarState({
        open: true,
        severity: "error",
        message: error?.message,
      });
    }
  };

  React.useEffect(() => {
    setTimeout(() => {
      if (gridRef.current) {
        const height = gridRef.current.getBoundingClientRect().height;
        setGridHeight(height);
      }
    }, 400);
    if (open) {
      if (chatBotData.selectedValue === "Support") {
        handleSupportCall();
      } else if (chatBotData.selectedValue === "Job") {
        handleChatBotFetchData();
      }
    }
  }, [open, minimizeScreen, location, resumeTab, value]);

  return (
    <CustomDiv
      background="#F6F8FB"
      height={"100vh"}
      overflowY="auto"
      display="flex"
    >
      <TabContext value={value}>
        <CommonGrid2
          width={open ? "calc(100% - 350px)" : "100%"}
          border={"1px solid rgba(0, 0, 0, 0.12)"}
          background="#fff"
          borderRadius={"10px"}
          height={"fit-content"}
          padding={"1rem"}
          margin={"0.8rem"}
          position={"relative"}
          sx={{
            transition: theme.transitions.create(["width"], {
              duration: theme.transitions.duration.short,
              easing: theme.transitions.easing.easeInOut,
            }),
          }}
        >
          <Typography variant="h2">Quick Match Demo</Typography>
          <Typography
            variant="h3"
            margin={"1rem 0px"}
            color="#5B738B"
            fontWeight={400}
          >
            Here is the Matching Report generated
          </Typography>

          <Slide
            direction="up"
            in={value === "0"}
            timeout={500}
            mountOnEnter
            unmountOnExit
          >
            <TabPanelView value="0" padding="1rem 0px 0px">
              <JobsSummary
                fetchData={fetchJobDataDetail}
                condition_based={true}
              />
            </TabPanelView>
          </Slide>

          <Slide
            direction="up"
            in={value === "1"}
            timeout={500}
            mountOnEnter
            unmountOnExit
          >
            <TabPanelView value="1" padding="1rem 0px 0px">
              <JemPlus
                jobData={jobData}
                jobId={jobId}
                handleDownloadJdOpen={handleDownloadJdOpen}
                fetchData={fetchJobDataDetail}
                handleClick={handleClick}
                saveEditData={saveEditData}
                resumeTab={resumeScore}
                condition_based={true}
                bounds={bounds}
              />
            </TabPanelView>
          </Slide>
          {resumeTab.map((elt, index) => (
            <Slide
              key={index}
              direction="up"
              in={value === (index + tabData.length).toString()}
              timeout={500}
              mountOnEnter
              unmountOnExit
            >
              <TabPanelView
                value={(index + tabData.length).toString()}
                padding="0px"
                key={index + tabData.length}
              >
                <JobsCandidate
                  matchedData={matchedData}
                  resumeId={resumeId}
                  resumeLoader={resumeLoader}
                  filteredResumeTab={filteredResumeTab}
                  fetchResumeData={fetchResumeData}
                  fetchData={fetchJobDataDetail}
                  handleQuestionMarkClick={() => {}}
                  iconVisible={false}
                  chatBotData={chatBotData}
                  condition_based={true}
                />
              </TabPanelView>
            </Slide>
          ))}
        </CommonGrid2>

        <CommonGrid2
          sx={{
            transition: theme.transitions.create(["width"], {
              duration: theme.transitions.duration.short,
              easing: theme.transitions.easing.easeInOut,
            }),
          }}
          width={open ? "350px" : "0px"}
          border={"1px solid rgba(0, 0, 0, 0.12)"}
          background="#fff"
          top={"0px"}
          position={"sticky"}
          height={"100%"}
          overflowY={"auto"}
          scrollStyle
          scrollBar="5px"
        >
          {open && (
            <>
              <CommonGrid2
                item
                ref={gridRef}
                padding={"0.5rem 1rem 0px"}
                overflowY={"scroll"}
                scrollStyle
                displayBar="none"
              >
                <CustomDiv>
                  <CommonGrid2
                    size="12"
                    margin="1rem 0px 1.2rem 0px"
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"space-between"}
                    gap={"10px"}
                  >
                    <Typography variant="h4" fontWeight={700}>
                      {query.get("title")}
                    </Typography>
                    <IconButton>
                      <HeartIco />
                    </IconButton>
                  </CommonGrid2>
                  <Collapse in={!minimizeScreen} timeout={400} unmountOnExit>
                    <CommonGrid2
                      size="12"
                      margin={"1rem 0px"}
                      gap={"3rem"}
                      alignItems={"center"}
                    >
                      <Typography variant="h5">Overall</Typography>
                      <CommonGrid2
                        container
                        spacing={2}
                        alignItems="center"
                        marginTop={1}
                      >
                        <JudicaTabViewSection
                          orientation="vertical"
                          onChange={handleChange}
                        >
                          {tabData.map((item, index) => {
                            return (
                              <Tab
                                key={index}
                                label={
                                  <CommonGrid2
                                    display={"flex"}
                                    alignItems={"center"}
                                    gap="10px"
                                  >
                                    {item.icon}
                                    {item.name}
                                  </CommonGrid2>
                                }
                                value={index.toString()}
                              />
                            );
                          })}
                        </JudicaTabViewSection>
                      </CommonGrid2>

                      <CommonGrid2
                        size="12"
                        margin={"1rem 0px 0px"}
                        display={"flex"}
                        gap={"1rem"}
                        alignItems={"center"}
                        justifyContent={"space-between"}
                      >
                        <Typography
                          variant="h5"
                          marginBottom={"10px"}
                          color="#344054"
                        >
                          Candidates
                        </Typography>
                        <CommonTippy
                          content="Add Candidates"
                          placement="top"
                          color={"#7F56D9"}
                          fontSize="12px"
                          bottom={"5px"}
                        >
                          <CustomDiv>
                            <CommonButton
                              value={"Add"}
                              variant="text"
                              startIcon={
                                backGroundprocess.openLoading ? (
                                  ""
                                ) : (
                                  <AddIcon
                                    sx={{
                                      stroke: "currentColor",
                                    }}
                                  />
                                )
                              }
                              gap="0px"
                              padding={"5px 15px"}
                              fontWeight={600}
                              borderRadius={"5px"}
                              disabled={true}
                              loading={backGroundprocess.openLoading}
                              onClick={handleAddMoreCandidateOpen}
                              customStyle={{
                                "&.Mui-disabled": {
                                  opacity: "0.8 !important",
                                  gap: "10px !important",
                                },
                              }}
                            />
                          </CustomDiv>
                        </CommonTippy>
                      </CommonGrid2>

                      <GlobalStyles
                        styles={{
                          "[data-rbd-placeholder-context-id]": {
                            background: "transparent !important",
                            border: "none !important",
                            margin: 0,
                            padding: 0,
                          },
                        }}
                      />

                      <DragDropContext onDragEnd={onDragEnd}>
                        <Droppable
                          droppableId="droppable-tabs"
                          direction="vertical"
                        >
                          {(provided) => (
                            <JudicaCandidateTabViewSection
                              orientation="vertical"
                              ref={provided.innerRef}
                              {...provided.droppableProps}
                              overflowY="auto !important"
                              scrollStyle={true}
                              scrollBar="5px"
                              scrollBarRadius="0px"
                              style={{ marginBottom: "0.8rem" }}
                              height={
                                value !== "0"
                                  ? "auto"
                                  : resumeTab.length >= 2
                                  ? "148px"
                                  : `${resumeTab.length * 49}px`
                              }
                            >
                              {resumeTab?.map((elt, index) => {
                                return tableLoader ? (
                                  <HandleSkeletion
                                    width="100%"
                                    height="45px"
                                    marginRight={"1rem"}
                                  />
                                ) : (
                                  <Draggable
                                    key={elt.id}
                                    draggableId={elt.id.toString()}
                                    index={index}
                                  >
                                    {(provided, snapshot) => (
                                      <Tab
                                        ref={provided.innerRef}
                                        {...provided.dragHandleProps}
                                        {...provided.draggableProps}
                                        onChange={handleChange}
                                        className={
                                          (
                                            index + tabData.length
                                          ).toString() === value
                                            ? "Mui-selected"
                                            : ""
                                        }
                                        label={
                                          <CommonGrid2
                                            display={"flex"}
                                            gap={"5px"}
                                            alignItems={"center"}
                                            justifyContent={"space-between"}
                                            width={"100%"}
                                          >
                                            <CommonGrid2
                                              display={"flex"}
                                              gap={"7px"}
                                              alignItems={"center"}
                                            >
                                              <CustomDiv
                                                style={{ cursor: "grab" }}
                                              >
                                                <SkillDrag />
                                              </CustomDiv>

                                              {elt?.name
                                                ? elt?.name
                                                : elt?.file_name}
                                            </CommonGrid2>
                                            <CustomDiv
                                              display="flex"
                                              alignItems="center"
                                              fontSize="12px"
                                              background={
                                                elt?.score > 70
                                                  ? "#ECFDF3"
                                                  : "#F9FAFB"
                                              }
                                              border={
                                                elt?.score > 70
                                                  ? "1px solid #AAEFC6"
                                                  : "1px solid #EAECF0"
                                              }
                                              color={
                                                elt?.score > 70
                                                  ? "#067647"
                                                  : "#344054"
                                              }
                                              borderRadius="50px"
                                              padding="4px 10px"
                                            >
                                              {elt?.score}%
                                            </CustomDiv>
                                          </CommonGrid2>
                                        }
                                        value={(
                                          index + tabData.length
                                        ).toString()}
                                        key={index + tabData.length}
                                        sx={{
                                          textTransform: "none",
                                          "&.Mui-selected": {
                                            color: "black",
                                            fontWeight: "bold",
                                          },
                                          ...(snapshot.isDragging && {
                                            background: "#ebebeb",
                                          }),
                                        }}
                                      />
                                    )}
                                  </Draggable>
                                );
                              })}

                              {provided.placeholder}
                            </JudicaCandidateTabViewSection>
                          )}
                        </Droppable>
                      </DragDropContext>
                    </CommonGrid2>
                  </Collapse>
                </CustomDiv>
              </CommonGrid2>
              <CommonGrid2
                size="12"
                height={`calc(100% - ${gridHeight + 28}px)`}
                boxShadow={
                  minimizeScreen ? "0px -4px 10px rgba(0, 0, 0, 0.1)" : "none"
                }
                transition={"box-shadow 0.3s ease-in-out"}
              >
                <Divider />
                <CommonButton
                  value={minimizeScreen ? "Minimize" : "Expand"}
                  variant="outlined"
                  color="#344054"
                  padding={"0px 1rem"}
                  background={"#fff"}
                  width="max-content"
                  fontWeight={"600"}
                  fontSize={"13px"}
                  gap="0px"
                  borderRadius={"50px"}
                  border={"#D0D5DD"}
                  startIcon={
                    minimizeScreen ? (
                      <KeyboardArrowDownIcon />
                    ) : (
                      <KeyboardArrowUpIcon />
                    )
                  }
                  customStyle={{
                    display: "flex",
                    position: "relative",
                    top: "-0.8rem",
                    margin: "auto",
                    "& .MuiButton-icon": {
                      marginRight: "5px",
                    },
                  }}
                  onClick={handleOverwriteClick}
                />
                <CommonGrid2
                  padding={"0 1rem 1rem"}
                  height={"100%"}
                  justifyContent={"space-between"}
                  display={"flex"}
                  flexDirection={"column"}
                >
                  <SideBarChatBot
                    chatBotPlaceholder="Ask Hailey about the Job ,Candidates"
                    handleToggleDrawer={handleToggleDrawer}
                    jobId={jobId}
                    height={minimizeScreen}
                    chatBotData={chatBotData}
                    // handleChatBotFetchData={handleChatBotFetchData}
                    handleSendMessage={handleSendMessage}
                    handleChatBotChange={handleChatBotChange}
                    isBottomVisible={isBottomVisible}
                    setIsBottomVisible={setIsBottomVisible}
                    handleUpArrow={handleUpArrow}
                    userName={localStorageData?.username}
                    buttonSupport={buttonSupport}
                    handleButtonSupport={handleButtonSupport}
                    title={"Quick Match Successful !"}
                    description={"Ask anything about the  Match Report"}
                  />
                </CommonGrid2>
              </CommonGrid2>
            </>
          )}
        </CommonGrid2>
      </TabContext>

      {/* Download JD Dailog */}
      <DownloadJD
        openDownloadJdDialog={openDownloadJdDialog}
        handleCloseDownloadJdDialog={handleCloseDownloadJdDialog}
        jdFileList={jdFileList}
        handleDownloadJd={handleDownloadJd}
        jdFileListLoader={jdFileListLoader}
      />
      {/* Add Candidate Resume */}
      <AddMoreCandidate
        addMoreCandidateDialogOpen={addMoreCandidateDialogOpen}
        handleAddMoreCandidateDialogClose={handleAddMoreCandidateDialogClose}
        handleAddMoreCandidateDragOver={handleAddMoreCandidateDragOver}
        handleAddMoreCandidateDragLeave={handleAddMoreCandidateDragLeave}
        handleAddMoreCandidateDrop={handleAddMoreCandidateDrop}
        handleAddMoreCandidateFileUpload={handleAddMoreCandidateFileUpload}
        addMoreCandidateFiles={addMoreCandidateFiles}
        isAddMoreCandidateDragging={isAddMoreCandidateDragging}
        handleAddMoreCandidateDeleteFile={handleAddMoreCandidateDeleteFile}
        handleAddMoreCandidateClick={handleAddMoreCandidateClick}
        isLoading={isLoading}
        isJem={false}
        // disabled={addMoreCandidateFiles?.length >= 1}
        disabled={isLoading}
        buttonDisabled={isLoading}
      />
      <SnackBar
        snackbarState={snackbarState}
        handleCloseValidation={handleCloseValidation}
      />
      <DialogCandidateHub
        open={backGroundprocess.open}
        // icon={<CandidateHub margin={"10px 0px 0px 10px"} />}
        title="Processing"
        titlepadding={"0px 0px 16px"}
        handleClose={handlebackGroundWarningClose}
        footer={<BackGroundFooter />}
        content={
          "A background process is in progress. Please wait a few minutes while it completes."
        }
      />
      <DialogCandidateHub
        open={saveEditData.open}
        icon={<CandidateHub margin={"10px 0px 0px 10px"} />}
        title="Save to JEM"
        handleClose={handleSaveCandidate}
        footer={<Footer />}
        titlepadding={"0px 0px 16px"}
        content={
          "You have unsaved changes. If you leave this page, your changes will be lost. Are you sure you want to proceed?"
        }
      />

      {!open && (
        <ChatBotRelative bottom={"11rem"}>
          <CustomTooltip
            title={
              <CustomDiv>
                <Typography color="#0070F2" fontWeight={600} fontSize={"16px"}>
                  Hi, {JSON.parse(localStorage.getItem("credential"))?.username}
                </Typography>
                <Typography color="#000" fontSize={"14px"} marginTop={"5px"}>
                  My name is Hailey. I am an here to help you surf this site,
                  Ask me anything you want to know
                </Typography>
                <Typography
                  color="#000"
                  fontSize={"10px"}
                  fontWeight={500}
                  textAlign={"end"}
                >
                  Click on the icon to start Chatting
                </Typography>
              </CustomDiv>
            }
            arrowHeight={{
              width: "23px",
              height: "16px",
              marginBottom: "-1rem !important",
            }}
            boxShadow={"0px 1px 2px 0px rgba(16, 24, 40, 0.05)"}
            beforeArrowHeight={{
              width: "23px",
              height: "16px",
            }}
            borderRadius={"10px"}
            backgroundColor="#fff"
            placement="top-end"
            border={"2px solid #D5DADD"}
          >
            <IconButton onClick={handleToggleDrawer} style={{ padding: "0px" }}>
              {chatBotData.selectedValue === "Candidate" ||
              chatBotData.selectedValue === "Job" ? (
                <ChatBotIcon />
              ) : (
                <SupportHaley />
              )}
            </IconButton>
          </CustomTooltip>
        </ChatBotRelative>
      )}
    </CustomDiv>
  );
}
